import React, { memo, useRef, useEffect, useCallback, useState} from 'react';
import {getStepData} from './getStepData.js';
import {
    setSelectedPianoRollSteps} from 'actions/index.js';
import {WIDTH} from '../pianoroll/constants.js';
import {connect} from 'react-redux';

const HEIGHT = 80;

const StepControl = memo(({
    controlParameter="velocity",
    color,
    duration,
    note,
    stepNumber,
    xScale,
    track,
    resolution,
    currentVelocity,
    setSelectedPianoRollSteps,
    selectedPianoRollSteps,
    controlRef,
    mouseDown,
    controlMouseDown,
}) => {

    let stepData= getStepData(track, parseFloat(stepNumber), parseFloat(note), resolution);
    let [v, setV] = useState(undefined);

    /*
     * I was trying to emulate the Cirklon view but that ends up fucking up how it works
     * in the most basic case: 
     */
    const onMouseOver = useCallback((e) => {
        let isMouseDown = mouseDown.current;
        if (isMouseDown) {
            let rect = controlRef.current.getBoundingClientRect();
            let y = e.clientY - rect.top;
            let height = Math.max(1, HEIGHT - y);
            let ratio = Math.min(1, height / HEIGHT);
            let parameter = stepData[controlParameter + "Parameter"];
            let value = parameter.min + ratio * (parameter.max - parameter.min);
            stepData[controlParameter] = value;
            setV(value);
        }
    }, [track, stepData, controlParameter, setV, stepNumber]);

    const onMouseDown = useCallback((e) => {
        e.stopPropagation();
        controlMouseDown.current = true;
        let selectedSteps = track.sequencerEngine.state.keyboard.selectedPianoRollSteps;
        if (!selectedSteps || !selectedSteps.includes(stepData)) {
            setSelectedPianoRollSteps([stepData]);
        }
    }, [stepData]);

    if (!stepData) {
        return [];
    }
    let parameterValue = stepData[controlParameter];
    let {min, max} = stepData[controlParameter + 'Parameter'];
    let ratio = (parameterValue - min) / (max - min);
    let height= Math.max(1, Math.min(HEIGHT, ratio * HEIGHT));
    let wrapperStyle = {
        left: stepNumber * WIDTH * xScale - 4,
        //zIndex: Math.round(1000.0 / Math.abs(parameterValue) - 5)
    };

    let style = {
        left: stepNumber * WIDTH * xScale,
        height,
        top: (HEIGHT) - height,
        backgroundColor: color,
        zIndex: Math.round(1000.0 / Math.abs(parameterValue))
    };

    let className = "step-control-circle";
    let isSelected =  selectedPianoRollSteps &&
        selectedPianoRollSteps.includes(stepData);
    if (isSelected) {
        className += " selected";
    }

    let circleStyle = {
        backgroundColor: color
    };
    return [
        <div
          data={parameterValue + ',' + wrapperStyle.zIndex}
          onMouseOver={onMouseOver}
          style={wrapperStyle}
          className="step-control-container">
          {isSelected ? <div className="param-tooltip">{parameterValue}</div> : ''}
          </div>
        ,
        <div
          style={style}
          className="step-control">
          <div
            onMouseDown={onMouseDown}
              style={circleStyle}
            className={className}/>
          </div>
    ];
});

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPianoRollSteps: (steps) => dispatch(setSelectedPianoRollSteps(steps)),
  };
};

export default connect(null, mapDispatchToProps)(StepControl);
